export default __webpack_public_path__ + "media/images/tenant/hero_1-1d9422480357ce59685c72311f4eaacb.webp";